import { Injectable, Component, Input, HostListener, ViewChild, AfterViewInit, OnInit } from "@angular/core";
import { AxonComponent } from "../../axon.component";
import { GoogleChartComponent } from "angular-google-charts";
import { ChartData, Chart } from "../../dto/dtos";

@Injectable({
    providedIn: 'root'
})

@Component({
    selector: 'app-axon-chart',
    templateUrl: './axon-chart.component.html',
    styleUrls: ['./axon-chart.component.scss'],
})
export class AxonChartComponent extends AxonComponent implements OnInit {

    @Input() chart:  Chart;
    options: any;
    data:    Array< any >;

    @ViewChild(GoogleChartComponent) chartComp: GoogleChartComponent;

    constructor() {
        super();
    }

    ngOnInit() {
        this.buildChartConfig();
    }

    ngOnChanges() {
        this.buildChartConfig();
    }

    private buildChartConfig() {
        if (!this.chart) {
            return;
        }

        console.log( '*****************************************************' );
        console.log( 'Building chart component [' + this.chart.title + ']' );

        console.log ( 'Column(s)', this.chart.columnNames );

        this.data = new Array();
        if ( Array.isArray( this.chart.data ) && this.chart.data.length > 0 ) {
            console.log( 'Using Standard Chart Data' );
            for ( const chartData of this.chart.data ) {
                console.log( 'Chart data [' + JSON.stringify( chartData ) + ']' );
                this.data.push(
                    [ chartData.title, chartData.value ]
                );
            }
        } else if ( Array.isArray( this.chart.comboData ) && this.chart.comboData.length > 0 ) {
            console.log( 'Using Combo Chart Data' );

            const columnNames = Array.isArray(this.chart.columnNames) ? [...this.chart.columnNames] : [];
            const normalizedColumnNames = this.normalizeComboColumnNames(columnNames, this.chart.comboData);
            this.chart.columnNames = normalizedColumnNames;

            for ( const comboData of this.chart.comboData ) {
                const arr = new Array< any >();

                for ( const val of comboData ) {
                    arr.push(this.normalizeChartValue(val));
                }

                if (arr.length < normalizedColumnNames.length) {
                    while (arr.length < normalizedColumnNames.length) {
                        arr.push(0);
                    }
                } else if (arr.length > normalizedColumnNames.length) {
                    arr.splice(normalizedColumnNames.length, arr.length - normalizedColumnNames.length);
                }

                this.data.push(arr);
            }
        }
        
        const params: Array< string > = (this.chart.params || '').split(';');

        this.options = {};
        for ( const p of params ) {
            if ( p ) {
                console.log( 'Param: [' + p + ']' );
                const name:  string       = p.split("=")[0];
                const value: Array< any > = p.split("=")[1].split(":");

                if ( name === 'colours' ) {
                    this.options.colors = value;
                } else if ( name === 'hAxis' ) {
                    this.options.hAxis = {
                        title: value[0]
                    };
                } else if ( name === 'vAxis' ) {
                    this.options.vAxis = {
                        title: value[0]
                    };
                } else if ( name === 'seriesType' ) {
                    this.options.seriesType = value[0];
                } else if ( name === 'series' ) {
                    this.options.series = {
                        2: { type: value[0] }
                    };
                }
            }
        }

        console.log( 'Options: ' + JSON.stringify(this.options) );
        console.log( '*****************************************************' );
    }

    private normalizeComboColumnNames(columnNames: any[], rows: any[][]): any[] {
        if (!Array.isArray(columnNames) || columnNames.length === 0) {
            const fallback = ['Date'];
            const sampleRow = rows[0] || [];
            for (let i = 1; i < sampleRow.length; i++) {
                fallback.push('Series ' + i);
            }
            return fallback;
        }

        const names = [...columnNames];
        const expectedLength = rows.length > 0 && Array.isArray(rows[0]) ? rows[0].length : names.length;

        if (names.length === expectedLength - 1) {
            return ['Date', ...names];
        }

        if (names.length < expectedLength) {
            while (names.length < expectedLength) {
                names.push('Series ' + names.length);
            }
        } else if (names.length > expectedLength) {
            return names.slice(0, expectedLength);
        }

        return names;
    }

    private normalizeChartValue(value: any): any {
        if (value === null || value === undefined || value === '') {
            return 0;
        }

        if (typeof value === 'string') {
            const trimmed = value.trim();
            if (trimmed === '') {
                return 0;
            }

            const numeric = Number(trimmed);
            if (!Number.isNaN(numeric)) {
                return numeric;
            }

            return trimmed;
        }

        if (typeof value === 'number') {
            return value;
        }

        return value;
    }

    // @HostListener('window:resize', ['$event'])
    // onWindowResize(event: any) {
    //     // let selection = this.chartComp.wrapper.getView().getSelection();
    //     // this.chartComp.wrapper.draw();
    //     // this.chartComp.wrapper.getView().setSelection(selection);
    //     // // you can remove two lines that preserve selection if you don't need them
    //     // console.log( 'screen resize' );
    // }

    
}